export const API_KEY: string = process.env.REACT_APP_API_KEY || "";
export const API_BASE_URL: string = "https://api.themoviedb.org/3";
export const IMAGE_BASE_URL: string =
  "https://www.themoviedb.org/t/p/w440_and_h660_face";
